import { BaseUnitOfWorkChangeRequest, EntityTypeModel } from "../basics/basics.models";
import { BaseValidationResponse } from "../validations/validations.models";

export interface WorkflowConfigurationModel {
    workflowConfigurationId: number;
    name: string;
    guid: string;
    isActive: boolean;
    isSelectable: boolean;
    entityTypeId: number | string;
    entityType: number;
    workflowActivities: WorkflowActivityModel[];
    branchId: number | string;
}

export interface WorkflowActivityModel {
    workflowActivityId: number;
    workflowConfigurationId: number;
    name: string;
    isActive: boolean;
    guid: string;
    isSelectable: boolean;
    meta: string;
    creationDate: string | Date;
    lastModified: string | Date;
    actionTakerBranchId?: number | string;
    actionTakerDepartmentId?: number | string;
    actionTakerDepartment?: string;
    internalName: string;
    pathResult?: number;
    parentActivityGuid: string;
    includeSubordinates: boolean;
}

export interface WorkflowAssignmentModel {
    workflowAssignmentId
    actionTakerId: number;
    actionTaker: string;
    isAccepted: boolean;
    isCurrentAssignment: boolean;
    reasonId: number;
    remarks: string;
    meta: string;
    configMeta: string;
    creationDate: string;
    lastModified: string;
    closedDate: string;
    actionTakerDepartmentId: number;
    actionTakerBranchId?: number;
    actionTakerDepartment: string;
    stepNumber: number;
    workflowState: WorkflowStateModel;
    workflowStateId: number;
    internalName: string;
    assignmentState: AssignmentStateModel;
}

export interface AssignmentStateModel {
    showUserAndDepartment: boolean;
    showStatus: boolean;
    isSystemAssignment: boolean;
    actionTakerAnonText: string;
    classList: string;
}

export interface WorkflowStateModel {
    workflowStateId: number;
    entityId: number;
    entityTypeId: number;
    state: number;
    workflowAssignments: WorkflowAssignmentModel[];
    workflowCancellationReasonId: number;
    workflowMeta: string;
    name: string;
    workflowStatusNotes?: string;
    workflowCancellationNotes?: string;
}

export class DeleteMessageConfirmationModel
{
    public question: string;
    public message: string
    public onDelete:() => void;
}

export enum WorkflowStateEnum {
    pending = 1,
    inProgress = 2,
    completed = 3,
    cancelled = 4,
    expired = 5,
    requestingInfo = 6
}

export interface WorkflowActivityComposeModel {
    item: any;
    assignment: WorkflowAssignmentModel;
    workflowState: WorkflowStateModel;
    isUpcomingAssignment: boolean;
    entityTypeId: number;
    reload: ((workflowState: WorkflowStateModel) => void);
}

export interface SaveWorkflowConfigurationRequest extends BaseUnitOfWorkChangeRequest { }

export interface GetWorkflowConfigurationsResponse {
    configurations: WorkflowConfigurationModel[];
    pathResults: WorkflowActivityPathResult[];
    workflowActivitySignatures: WorkflowActivitySignature[];
}

export interface WorkflowActivityPathResult {
    workflowActivityPathResultId: number;
    name: string;
}

export interface WorkflowActivitySignature {
    internalName: string;
    displayName: string;
    shape: string;
    background: string;
    pathResults: number[];
}

export interface SaveWorkflowConfigurationResponse extends BaseValidationResponse {
    workflowConfiguration: WorkflowConfigurationModel;
}

export interface GetEntityTypesForWorkflowResponse {
    entityTypes: EntityTypeModel[];
}

export interface GetWorkflowStateResponse {
    workflowState: WorkflowStateModel;
    entityType: string;
    canTakeOwnership: boolean;
    canReassign: boolean;
}

export interface WorkflowTakeOwnershipResponse {
    workflowState: WorkflowStateModel;
}

export interface CloneWorkflowConfigurationResponse {
    isSuccess: boolean;
    workflowConfiguration: WorkflowConfigurationModel;
}

export interface CloneWorkflowConfigurationRequest {
    workflowConfigurationId: number;
    clonedWorkflowName: string;
}

export interface WorkflowAcceptRequest {
    assignmentId: number;
    reasonId: number;
    remarks: string;
    meta: string;
}

export interface WorkflowStateUpdatedResponse {
    workflowState: WorkflowStateModel;
    canTakeOwnership: boolean;
    canReassign: boolean;
    errorMessage: string;
}
